<template>
    <div id="chatView">
        <Header title="Brendon" :show-back="true"></Header>
        <!--聊天区域-->
        <div class="msgWrap">
            <div class="msgList" v-for="(item,index) in msgList" :key="index"
                 :class="item.from_uid === myId ? 'mine' : '' ">
                <div class="left">
                    <img src="../../assets/img/user/avatar.png" alt=""/>
                    <span>客户</span>
                </div>
                <div class="right">
                    <span>{{formatDate(item.addtime,2)}}</span>
                    <div>{{item.content}}</div>
                </div>
            </div>
        </div>
        <!--底部-->
        <div class="footer">
            <div class="inputBox">
                <input type="text" v-model="msg">
                <!--<img src="../../assets/img/sendImg.png" alt="" class="sendImg"/>-->
            </div>
            <button @click="send">发送</button>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        name: "chatView",
        components: {
            Header
        },
        data() {
            return {
                msg: "",
                myId: "",
                msgList: [],
                t: null
            }
        },
        created() {
            this.t = setInterval(() => {
                this.getMsgList();
            }, 1000);
        },
        methods: {
            send() {
                let obj = {
                    order_id: this.$route.query.id,
                    msg_type: "text",
                    content: this.msg,
                };
                this.ajax.post('appapi/c2c/upload_chat_msg', obj).then((res) => {
                    if (res.data.code === 1) {
                        this.msg = "";
                    }
                });
            },
            // 获取聊天列表
            getMsgList() {
                this.ajax.post('appapi/c2c/get_chat_msgs', {order_id: this.$route.query.id}).then((res) => {
                    if (res.data.code === 1) {
                        this.myId = res.data.data.mine_uid;
                        this.msgList = res.data.data.chats;
                    }
                });
            }
        },
        beforeDestroy() {
            clearInterval(this.t);
        }
    }
</script>

<style lang="scss" scoped>
    #chatView {
        display: flex;
        flex-direction: column;
        height: 100vh;

        .msgWrap {
            flex: 1;
            padding: 55px 30px 98px;
            background: #F9F9F9;

            .msgList {
                display: flex;
                margin-bottom: 87px;

                .left {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-right: 25px;

                    img {
                        width: 70px;
                        height: 70px;
                        margin-bottom: 14px;
                        border-radius: 50%;
                    }

                    span {
                        font-size: 22px;
                        font-weight: 500;
                        color: #777777;
                    }
                }

                .right {
                    display: flex;
                    flex-direction: column;

                    span {
                        margin-bottom: 16px;
                        font-size: 24px;
                        font-weight: 500;
                        color: rgba(119, 119, 119, 1);
                        flex-grow: 0;
                        text-align: right;
                    }

                    div {
                        max-width: 60vw;
                        word-wrap: break-word;
                        padding: 19px 32px;
                        border-radius: 10px;
                        background: #F2F2F2;
                        flex-grow: 0;
                    }
                }
            }

            .mine {
                flex-direction: row-reverse;
                justify-content: flex-start;

                .left {
                    margin-right: 0;
                    margin-left: 25px;
                }

                .right {
                    div {
                        background: #0ec15e;
                    }
                }
            }
        }

        .footer {
            position: fixed;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100vw;
            height: 98px;
            padding: 13px 30px;
            background: #fff;

            .inputBox {
                position: relative;
                display: flex;
                align-items: center;
                width: 544px;
                height: 72px;
                padding: 0 24px;
                margin-right: 26px;
                background: #F4F4F4;
                border-radius: 36px;

                input {
                    width: 100%;
                    height: 100%;
                    border-radius: 10px;
                    background: #f2f2f2
                }

                .sendImg {
                    position: absolute;
                    right: 24px;
                    width: 42px;
                    height: 42px;
                    background: aliceblue;
                }
            }

            button {
                width: 120px;
                height: 72px;
                border-radius: 36px;
                font-size: 28px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                background: rgba(14, 193, 94, 1);
            }
        }
    }
</style>
